@if (storeContactDetails()?.contact_mobile_number || storeContactDetails()?.contact_email) {
<div id="contact-info-panel" class="contact-info-panel-container" [ngClass]="{
    'hide-in-desktop': !contactInfoPanelConfiguration()?.showDesktopContactInfoPanel,
    'hide-in-mobile': !contactInfoPanelConfiguration()?.showMobileContactInfoPanel
  }">
    <div class="contact-info-panel editable">
        @if (storeContactDetails()?.contact_mobile_number; as contactNumber) {
        <p class="contact-info-item">
            <img [src]="contactInfoPanelConfiguration()?.contactIcon" alt="Phone Icon" class="contact-info contact-icon editable" />
            <span class="contact-info-contact">
                {{ contactNumber }}
            </span>
        </p>
        } @if (storeContactDetails()?.contact_email; as contactMail) {
        <p class="contact-info-item">
            <img [src]="contactInfoPanelConfiguration()?.emailIcon" alt="Email Icon" class="contact-info email-icon editable" />
            <span class="contact-info-email">{{ contactMail }} </span>
        </p>
        }
    </div>
</div>
}